export default __webpack_public_path__ + "static/media/Resume.cf4cade3.pdf";